import clsx from "clsx";
import React from "react";
import { useTheme } from "../../hooks/useTheme";
import { TypographyDiv, TypographyH1, TypographyH2, TypographyH3, TypographyH4, TypographyH5, TypographyH6, TypographyParagraph, TypographySpan, } from "./TypographyStyles";
/**
 * Text component to display formatted, styled text in an application
 */
const Typography = ({ variant = "body1", className = "", children, styles = {}, elementStyles = {}, ...rest }) => {
    const { Theme } = useTheme();
    const StylesOverride = { ...Theme.typography, ...styles };
    const getStyles = () => {
        return { ...StylesOverride[variant], ...elementStyles };
    };
    switch (variant) {
        case "h1":
            return (React.createElement(TypographyH1, { className: clsx(className), styles: getStyles(), ...rest }, children));
        case "h2":
            return (React.createElement(TypographyH2, { className: clsx(className), styles: getStyles(), ...rest }, children));
        case "h3":
            return (React.createElement(TypographyH3, { className: clsx(className), styles: getStyles(), ...rest }, children));
        case "h4":
            return (React.createElement(TypographyH4, { className: clsx(className), styles: getStyles(), ...rest }, children));
        case "h5":
            return (React.createElement(TypographyH5, { className: clsx(className), styles: getStyles(), ...rest }, children));
        case "h6":
            return (React.createElement(TypographyH6, { className: clsx(className), styles: getStyles(), ...rest }, children));
        case "div":
            return (React.createElement(TypographyDiv, { className: clsx(className), styles: getStyles(), ...rest }, children));
        case "span":
            return (React.createElement(TypographySpan, { className: clsx(className), styles: getStyles(), ...rest }, children));
        case "body1":
        case "body2":
        case "body3":
        case "caption":
        case "subtitle1":
        case "subtitle2":
        default:
            return (React.createElement(TypographyParagraph, { className: clsx(className), styles: getStyles(), ...rest }, children));
    }
};
export default Typography;
//# sourceMappingURL=Typography.js.map